import { FieldSpecRepeater } from "../spec-repeater/FieldSpecRepeater";

const AgencyAccreditationFields = props => {

  const {
    value,
  } = props

  return (
    <>
      <div className="tgbl-cred-accreditation-fields tgbl-field-block">
        <div className="tf-pseudo-description" >Define additional data that varies per accreditation within this Agency</div>
        <FieldSpecRepeater
          name={'agency_accreditation_fields'}
          value={value.accreditation_fields ?? []}
        />
      </div>
    </>
  )
}

export { AgencyAccreditationFields }
